if (!customElements.get('button-price-display')) {
  customElements.define(
    'button-price-display',
    class ButtonPriceDisplay extends HTMLElement {
      constructor() {
        super();
        
        this.wrapper = this.querySelector('.onhow-button-price__wrapper');
        this.compareElement = this.querySelector('.onhow-button-price__compare');
        this.currentElement = this.querySelector('.onhow-button-price__current');
        
        this.sectionId = this.dataset.sectionId;
        this.variantPrice = parseInt(this.dataset.variantPrice) || 0;
        this.comparePrice = parseInt(this.dataset.comparePrice) || 0;
        this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
        this.currencyCodeEnabled = this.dataset.currencyCodeEnabled === 'true';
        
        this.quantityInput = document.querySelector(`#Quantity-${this.sectionId}`);
      }

      connectedCallback() {
        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          this.handleVariantChange.bind(this)
        );
        
        if (this.quantityInput) {
          this.quantityInput.addEventListener('change', this.updatePrice.bind(this));
          this.quantityInput.addEventListener('input', this.updatePrice.bind(this));
        }
        
        this.quantityChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.quantityUpdate,
          this.updatePrice.bind(this)
        );
        
        this.updatePrice();
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
        if (this.quantityChangeUnsubscriber) {
          this.quantityChangeUnsubscriber();
        }
      }

      handleVariantChange(event) {
        const variant = event.data?.variant;
        if (!variant) return;
        
        this.variantPrice = variant.price;
        this.comparePrice = variant.compare_at_price || 0;
        
        this.updatePrice();
      }

      updatePrice() {
        const quantity = this.quantityInput ? parseInt(this.quantityInput.value) || 1 : 1;
        
        const totalPrice = Math.max(0, this.variantPrice * quantity);
        const totalComparePrice = this.comparePrice > 0 ? this.comparePrice * quantity : 0;
        
        const formattedPrice = this.formatMoney(totalPrice);
        const formattedComparePrice = totalComparePrice > 0 ? this.formatMoney(totalComparePrice) : null;
        
        if (this.currentElement) {
          this.currentElement.textContent = formattedPrice;
        }
        
        if (formattedComparePrice && totalComparePrice > totalPrice) {
          if (!this.compareElement) {
            this.compareElement = document.createElement('s');
            this.compareElement.className = 'onhow-button-price__compare';
            this.wrapper.insertBefore(this.compareElement, this.currentElement);
          }
          this.compareElement.textContent = formattedComparePrice;
          this.compareElement.style.display = '';
        } else if (this.compareElement) {
          this.compareElement.style.display = 'none';
        }
        
        this.updateQuantityIndicator(quantity);
      }

      updateQuantityIndicator(quantity) {
        let qtyIndicator = this.querySelector('.onhow-button-price__qty');
        
        if (quantity > 1) {
          if (!qtyIndicator) {
            qtyIndicator = document.createElement('span');
            qtyIndicator.className = 'onhow-button-price__qty';
            this.wrapper.appendChild(qtyIndicator);
          }
          qtyIndicator.textContent = `×${quantity}`;
          qtyIndicator.style.display = '';
        } else if (qtyIndicator) {
          qtyIndicator.style.display = 'none';
        }
      }

      formatMoney(cents) {
        if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
          return Shopify.formatMoney(cents, this.moneyFormat);
        }
        
        const dollars = (cents / 100).toFixed(2);
        return this.moneyFormat.replace('{{amount}}', dollars);
      }
    }
  );
}
